import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import AppFeaturesSection from '@/pages/home/components/AppFeaturesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AboutIndexSection from '@/pages/home/components/AboutIndexSection';
import FAQCommentsSection from '@/pages/home/components/FAQCommentsSection';
import CardsTopicsSection from '@/pages/home/components/CardsTopicsSection';
import UpdatesContactSection from '@/pages/home/components/UpdatesContactSection';
import MediaRankingSection from '@/pages/home/components/MediaRankingSection';
import FooterSection from '@/pages/home/components/FooterSection';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <AppFeaturesSection />
        <CarouselSection />
        <AboutIndexSection />
        <FAQCommentsSection />
        <CardsTopicsSection />
        <UpdatesContactSection />
        <MediaRankingSection />
      </main>
      <FooterSection />
    </div>
  );
}